/**
 * Created by lixinwei on 17/7/13.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'
import rcapp from './modules/rcapp'
import rcproduct from './modules/rcproduct'
//import stpOptionStore from '../views/stp/components/interact/stpOptionStore'

Vue.use(Vuex);


/* 项目全局State */
const state = {
    ajax_loading: false,
    token: {},
    user: { name: 'wangeng' }
}

/* Store实例 */
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    modules: {
        rcapp,
        rcproduct,
//        stpOptionStore
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js